// extracted by mini-css-extract-plugin
module.exports = {"form":"Input_form__2NCag","label":"Input_label__2Z-ia","input":"Input_input__215eP","button__balance":"Input_button__balance__1joSb"};